import { ReactComponent as CircleCheckIcon } from 'assets/icons/circlecheck.svg'
import { ReactComponent as DangerIcon } from 'assets/icons/danger.svg'
import Lozenge from 'components/Tiles/Lozenge'
import { bodyPrimaryColor, confirmColor, primaryBackgroundColor, errorRed, warningYellow } from 'styles/styleVariables'
import type { Prescription } from 'types'
import { getLastFillDate } from 'utils'

const RxLastFill = ({ prescription }: { prescription: Prescription }): JSX.Element => {
  const lastFillDate = getLastFillDate(prescription)
  if (!lastFillDate) {
    return <>Not Applicable</>
  }

  let fillTimeLozenge: JSX.Element | null = null
  if (prescription?.lastEquivalentDrugDispensedInfo) {
    const {
      nextFillInfo: { daysLeft, isOkToFill },
    } = prescription.lastEquivalentDrugDispensedInfo

    const isPastDue = daysLeft <= 0

    const pastDueLozenge = (
      <Lozenge backgroundColor={warningYellow}>
        <CircleCheckIcon fill={bodyPrimaryColor} style={{ marginRight: '0.25rem' }} />
        PAST DUE
      </Lozenge>
    )

    const dueInLozenge = (
      <Lozenge backgroundColor={isOkToFill ? confirmColor : errorRed}>
        {isOkToFill ? <CircleCheckIcon fill={primaryBackgroundColor} /> : <DangerIcon fill={primaryBackgroundColor} />}
        DUE IN: {daysLeft} DAY{daysLeft !== 1 && 'S'}
      </Lozenge>
    )

    fillTimeLozenge = isPastDue ? pastDueLozenge : dueInLozenge
  }

  return (
    <>
      {lastFillDate} {fillTimeLozenge}
    </>
  )
}

export default RxLastFill
